import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import { NavItem } from 'react-bootstrap';

import authContext from '../../context/auth/authContext.js';

import { UIActions } from '../../presentation/redux/actions/UIActions';
import { handleLogout } from '../../presentation/utils/handleLogout.ts';
import { fetchLogoFromLocalStorage } from '../action/fetchLogoById';
import { getInfo } from '../action/pdv/getInfo';

import logo from '../../img/logo.svg';
import logoHorizontal from '../../img/logo-horizontal.svg';
import loadingImg from '../../img/img-loading3.gif';

import '../menu/menu.css';

function Menu(props) {
  const dispatch = useDispatch();
  const history = useNavigate();
  const AuthContext = useContext(authContext);
  const { token, es_pin, cambiar_pin } = AuthContext;
  const [logoUrl, setLogoUrl] = useState(loadingImg);
  const [logoHorizontalUrl, setLogoHorizontalUrl] = useState(loadingImg);

  let id = localStorage.getItem("dst_Id");

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        if (id) {
          const url = await fetchLogoFromLocalStorage(id);
          if (url) {
            setLogoUrl(url);
            setLogoHorizontalUrl(url);
          } else {
            setLogoUrl(logo);
            setLogoHorizontalUrl(logoHorizontal);
          }
        } else {
          setLogoUrl(logo);
          setLogoHorizontalUrl(logoHorizontal);
        }
      } catch (error) {
        setLogoUrl(logo);
        setLogoHorizontalUrl(logoHorizontal);
      }
    };

    fetchLogo();
  }, [id]);

  if (cambiar_pin) {
    Swal.fire({
      title: "Actualizar contraseña",
      text: "Por motivos de seguridad, te recomendamos actualizar tu contraseña. Para proteger tu cuenta y tus datos personales, es importante utilizar una contraseña fuerte y única. Da clic en 'Aceptar' para actualizar tu contraseña.",
      icon: 'warning',
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.isConfirmed) {
        history('/updatepassword');
      }
    })
  }

  const handleTwoFactor = () => {
    dispatch(UIActions.openTwoFactorAuthentication());
    getInfo(token, dispatch);
  }

  return (
    <Navbar bg="white" expand="lg" className="justify-content-between">
      <Navbar.Toggle aria-controls="basic-navbar-nav"/>
      {/* Logo móvil */}
      <Navbar.Brand href="/home" className="logo-mobile d-lg-none">
        <img src={logoUrl} alt="logo" style={{ width: '100%', maxWidth: '100px', height: 'auto', maxHeight: '60px' }} />
      </Navbar.Brand>
      <Navbar.Collapse id="basic-navbar-nav">
        {/* Logo escritorio */}
        <Navbar.Brand href="/home" className="logo-desktop d-none d-lg-block">
          <img src={logoHorizontalUrl} alt="logo" style={{ width: '100%', maxWidth: '200px', height: 'auto', maxHeight: '80px' }} />
        </Navbar.Brand>
        <Nav className="ml-auto">
          {/* <NavDropdown title="Ayuda" id="basic-nav-dropdown">
            <NavDropdown.Item >
              Reportar Pago
              <br />
              <small className='text-danger'>Próximamente</small>
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item >Realizar Venta</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item >Reportes</NavDropdown.Item>

            <NavDropdown.Divider />
            <NavDropdown.Item onClick={() => {
              dispatch(UIActions.openModalHelp())
            }} >Ayuda</NavDropdown.Item>
          </NavDropdown> */}
          <NavDropdown title="Configuración" id="basic-nav-dropdown">
            <NavDropdown.Item onClick={() => {
              dispatch(UIActions.openChangePassword())
            }} >Contraseña</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={() => {
              dispatch(UIActions.openSessionTime())
            }} >Tiempo de Sesión</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={() => {
              dispatch(UIActions.openCommissions())
            }} >Comisiones</NavDropdown.Item>
            {
              (!es_pin) &&
              <>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/pines-usuarios">
                  Pines Usuario
                </NavDropdown.Item>
              </>
            }
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={handleTwoFactor} >
              <small className='text-danger'>¡Nuevo!</small>
              <br />
              Verificación en 2 pasos
            </NavDropdown.Item>

          </NavDropdown>

          <NavItem className="btn text-muted text-left p-0 d-block d-md-none" onClick={handleLogout}>Cerrar sesión</NavItem>
        </Nav>
      </Navbar.Collapse>
      <button type="button"
        className="d-none d-md-block btn btn-logout ml-md-4" onClick={handleLogout}>Cerrar Sesión</button>
    </Navbar >
  );
} export default Menu;